import styled from 'styled-components';
import { font, color, mixin } from 'shared/utils/styles';

export const StyledHeader = styled.div`
  border-bottom: 1px solid ${color.border};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  background-color: ${color.white};
  height: 60px;
`;

export const StyledTrigger = styled.div`
  transition: color 0.3s;
  ${font.size(20)}
  ${mixin.clickable}
    
  &:hover {
    color: ${color.primary};
  }
`;

export const TextHeader = styled.div`
  padding-left: 20px;
  ${font.size(20)}
  ${font.bold}
`;

export const LeftContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 60px;
  flex: 1;
`;

export const RightContainer = styled.div`
  .ant-btn-link {
    color: ${color.black};
  }
`;
